import { render, staticRenderFns } from "./ConfirmWithInvalidationReasonAndCommentModal.vue?vue&type=template&id=647a47be&scoped=true"
import script from "./ConfirmWithInvalidationReasonAndCommentModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmWithInvalidationReasonAndCommentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647a47be",
  null
  
)

export default component.exports